"use client";

import React from "react";
import { ArrowRight, Code, LayoutTemplate, Sparkles, Terminal } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReviveYourHtmlCode() {
  const {
    ref: leftRef,
    isVisible: isLeftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: isRightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224356" id="the-digital-forge" className="bg-background text-foreground relative overflow-hidden min-h-screen flex items-center ![padding:0px_0px_80px_0px]">
      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--color-border)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-border)_1px,transparent_1px)] bg-[size:100px_100px] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_50%,#000_70%,transparent_100%)] opacity-10 pointer-events-none" />
      
      {}
      <div className="absolute top-1/2 left-1/4 -translate-y-1/2 w-[30rem] h-[30rem] bg-primary/10 rounded-lg blur-[120px] pointer-events-none" />
      <div className="absolute top-1/2 right-1/4 -translate-y-1/2 w-[20rem] h-[20rem] bg-chart-4/10 rounded-lg blur-[100px] pointer-events-none" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full max-w-7xl">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          
          {}
          <div ref={leftRef} className={`lg:col-span-7 flex flex-col items-start transition-all duration-1000 ease-out ${isLeftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-primary/10 border border-border text-primary text-sm font-mono mb-6">
              <Sparkles className="w-4 h-4" />
              <span>ENGINEERING EXCELLENCE</span>
            </div>
            
            <h1 className="font-default text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold tracking-tighter mb-6 leading-[1.1] uppercase">
              FORGING DIGITAL <br className="hidden sm:block" />
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-primary via-chart-4 to-primary">
                SUPREMACY
              </span>
            </h1>
            
            <p className="font-mono text-lg sm:text-xl text-muted-foreground mb-8 max-w-2xl leading-relaxed">DEVLUX helps eCommerce brands scale through paid advertising, organic content, and creator-driven marketing. Our team combines data, creativity, and proven growth systems to maximize revenue across every channel.</p>
            
            <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
              <Link to="#" className="w-full sm:w-auto">
                
              </Link>
              <Link to="/TheForgePage" className="w-full sm:w-auto">
                
              </Link>
            </div>
            
            <div className="mt-10 flex items-center gap-6 text-sm font-mono text-muted-foreground">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-md bg-primary animate-pulse" />
                <span>SCALABLE ARCHITECTURE</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-md bg-chart-4 animate-pulse" style={{
                animationDelay: "0.5s"
              }} />
                <span>MEASURABLE RESULTS</span>
              </div>
            </div>
          </div>

          {}
          <div ref={rightRef} className={`lg:col-span-5 relative perspective-[1200px] transition-all duration-1000 delay-300 ease-out ${isRightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            {}
            <div className="relative transform-gpu transition-transform duration-700 hover:rotate-y-0 hover:rotate-x-0 rotate-y-[-12deg] rotate-x-[8deg] shadow-2xl rounded-md overflow-hidden border border-border bg-card/40 backdrop-blur-xl flex h-[400px] sm:h-[480px] w-full max-w-[500px] mx-auto group">
              
              {}
              <div className="w-1/2 bg-background border-r border-border flex flex-col relative overflow-hidden">
                {}
                <div className="h-10 bg-card border-b border-border flex items-center px-4 gap-2 shrink-0">
                  <div className="w-3 h-3 rounded-md bg-border" />
                  <div className="w-3 h-3 rounded-md bg-border" />
                  <div className="w-3 h-3 rounded-md bg-border" />
                  <div className="ml-2 flex items-center gap-1.5 text-xs text-muted-foreground font-mono">
                    <Terminal className="w-3 h-3" /> forge.config.js
                  </div>
                </div>
                {}
                <div className="p-4 font-mono text-[10px] sm:text-xs leading-relaxed text-muted-foreground overflow-hidden">
                  <div className="text-primary/70 mb-1">{"module.exports = {"}</div>
                  <div className="text-chart-3/80 pl-4">agency: 'DEVLUX',</div>
                  <div className="pl-4 text-chart-3/80">{"stack: ["}</div>
                  <div className="pl-8 text-foreground">{"'React', 'Node.js',"}</div>
                  <div className="pl-8 text-foreground">{"'CloudNative'"}</div>
                  <div className="pl-4 text-chart-3/80">{"],"}</div>
                  <div className="pl-4 text-chart-3/80">{"output: {"}</div>
                  <div className="pl-8 text-primary/90 mt-2">{"performance: '99+',"}</div>
                  <div className="pl-8 text-chart-2/90">{"security: 'Hardened',"}</div>
                  <div className="pl-8 text-foreground">{"ux: 'Premium'"}</div>
                  <div className="pl-4 text-chart-3/80">{"}"}</div>
                  <div className="text-primary/70 mt-2">{"};"}</div>
                </div>
                
                {}
                <div className="absolute top-0 left-0 w-full h-1 bg-primary/30 animate-[scan_3s_ease-in-out_infinite]" style={{
                animationName: 'scan'
              }} />
              </div>

              {}
              <div className="w-1/2 bg-card flex flex-col relative overflow-hidden">
                {}
                <div className="h-10 bg-background border-b border-border flex items-center justify-between px-3 shrink-0">
                  <div className="flex items-center gap-1.5 text-xs font-bold text-foreground uppercase tracking-widest">
                    <LayoutTemplate className="w-4 h-4 text-primary" /> DEPLOY
                  </div>
                  <Button variant="default" size="sm" className="h-6 text-[10px] px-2 bg-primary hover:bg-primary/80 text-primary-foreground rounded-md">SYNC</Button>
                </div>
                
                {}
                <div className="p-3 flex flex-col gap-3 h-full bg-background/50">
                  {}
                  <div className="w-full h-8 rounded-md border border-border bg-card flex items-center px-2 group/block hover:border-primary/50 transition-colors">
                    <div className="w-16 h-2 bg-muted rounded-md" />
                    <div className="ml-auto flex gap-1">
                      <div className="w-6 h-2 bg-muted rounded-md" />
                      <div className="w-6 h-2 bg-muted rounded-md" />
                    </div>
                  </div>
                  
                  {}
                  <div className="w-full flex-1 rounded-md border border-primary/30 bg-primary/5 relative group/block flex flex-col items-center justify-center p-4 text-center">
                    <div className="absolute top-1 right-1 flex gap-1 opacity-0 group-hover/block:opacity-100 transition-opacity">
                       <div className="w-4 h-4 rounded-md bg-primary/20 flex items-center justify-center"><Code className="w-2 h-2 text-primary" /></div>
                    </div>
                    <div className="w-3/4 h-4 bg-foreground/80 rounded-md mb-2" />
                    <div className="w-1/2 h-4 bg-foreground/80 rounded-md mb-4" />
                    <div className="w-full h-2 bg-muted-foreground/40 rounded-md mb-1" />
                    <div className="w-4/5 h-2 bg-muted-foreground/40 rounded-md mb-4" />
                    <div className="w-20 h-6 bg-primary rounded-md mt-auto" />
                  </div>
                </div>
              </div>

              {}
              <div className="absolute inset-y-0 left-1/2 -translate-x-1/2 w-12 pointer-events-none flex flex-col justify-center gap-12 z-20 mix-blend-screen">
                <div className="relative h-px w-full bg-gradient-to-r from-transparent via-primary to-transparent opacity-80">
                  <div className="absolute top-1/2 left-0 w-2 h-2 bg-primary rounded-md -translate-y-1/2 animate-[stream_2s_linear_infinite]" />
                </div>
                <div className="relative h-px w-full bg-gradient-to-r from-transparent via-chart-4 to-transparent opacity-80 translate-x-4">
                  <div className="absolute top-1/2 left-0 w-2 h-2 bg-chart-4 rounded-md -translate-y-1/2 animate-[stream_2.5s_linear_infinite_0.5s]" />
                </div>
                <div className="relative h-px w-full bg-gradient-to-r from-transparent via-primary to-transparent opacity-80 -translate-x-2">
                  <div className="absolute top-1/2 left-0 w-2 h-2 bg-primary rounded-md -translate-y-1/2 animate-[stream_1.8s_linear_infinite_1s]" />
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>

      <style dangerouslySetInnerHTML={{
      __html: `
        @keyframes scan {
          0%, 100% { top: 0; opacity: 0; }
          10%, 90% { opacity: 1; }
          50% { top: 100%; }
        }
        @keyframes stream {
          0% { left: 0; opacity: 0; transform: scale(0.5) translateY(-50%); }
          20% { opacity: 1; transform: scale(1) translateY(-50%); }
          80% { opacity: 1; transform: scale(1) translateY(-50%); }
          100% { left: 100%; opacity: 0; transform: scale(0.5) translateY(-50%); }
        }
      `
    }} />
    </section>;
}